export default {
  error: 'global.titles.error',
  unknownError: 'global.titles.unknown-error',
  pageNotFound: 'global.errors.page-not-found'
}
